<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :style="{ '--icon-size': typeof size === 'number' ? `${size}px` : size }"
    :class="['lucide', 'lucide-circle-user', { 'is-blue': variant === 'blue' }]"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="10" r="3" />
    <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [Number, String], default: 24 },
  variant: {
    type: String,
    default: 'inherit',
    validator: value => ['inherit', 'blue'].includes(value),
  },
})
</script>

<style scoped>
.lucide-circle-user {
  display: inline-block;
  vertical-align: middle;
  width: var(--icon-size, 1.5rem);
  height: var(--icon-size, 1.5rem);
  color: currentColor;
}

.lucide-circle-user.is-blue {
  color: #60a5fa;
}
</style>
